
import XButton from 'vux/src/components/x-button/index.vue'

import { SaafHeader } from '@/common/components/index'
import { mapState } from 'vuex'

import {service,nativeApi} from '@/common/index'




export default {
data () {
return {

}
},
components: {
SaafHeader,
XButton,
},
computed: {
...mapState({
userInfo: state => state.user.userInfo,
guideInfo: state => state.user.guideInfo,
shopInfo: state => state.user.shopInfo,
orgInfo: state => state.user.orgInfo,
phoneInfo: state => state.user.phoneInfo,
custom: state => state.custom,
}),
},
created(){
nativeApi.initRnRunH5Function({
testFun1:(data)=>{
this.$vux.toast.text(111111)
return true
},
testFun2:(data)=>{
this.$vux.toast.text(22222)
return false
},
testFun3:(data)=>{
return new Promise((resolve, reject) => {
this.$vux.toast.text(33333)
setTimeout(()=>{
resolve({testValue: true})
},5000)
})

}
})
},
methods: {
showPhoneMsg(){
alert(JSON.stringify(this.phoneInfo))
},
barcodeScannerStore(){
nativeApi.nativeFN.barcodeScannerStore({codePrefix:111,pointData:222},(data)=>{
this.$vux.toast.text(data)
})
},
isRetrial(){
nativeApi.nativeFN.FlowRetrial()
},
FlowStart(){
nativeApi.nativeFN.FlowStart()
},
rnRouter(){
nativeApi.nativeFN.rnRouter({
url:'messageList',
props:{}
})
},
rnApproval(flag){
nativeApi.nativeFN.rnRouterApproval({
processKey:'OA_SEAL_TASK',
saveFlag: flag
})
},
closeWindow(){
nativeApi.nativeFN.closeWindow()
},
call(){
nativeApi.nativeFN.phoneCall('400123123')
},
wechat(){
nativeApi.nativeFN.openWechat()
},
showUserMsg(type){
alert(JSON.stringify(this[type]))
},
showUserMsgKey(type){
alert(JSON.stringify(this[type].certificate))
},
showOrgId(){
alert(JSON.stringify(this.orgInfo.orgId))
},
gps(){
nativeApi.nativeFN.geolocation((data)=>{
this.$vux.toast.text(data)
})
},
barcodeScanner(){
nativeApi.nativeFN.barcodeScanner((data)=>{
this.$vux.toast.text(data)
})
},
barcodeScannerS(){
nativeApi.nativeFN.barcodeScannerS((data)=>{
this.$vux.toast.text(data)
})
},
takePhoto(){





nativeApi.nativeFN.takePhoto((data)=>{
setTimeout(()=>{
alert(JSON.stringify(data))
},500)
})
},
logout(){
nativeApi.nativeFN.logout()
},
testStore(){
alert(this.custom.testValue)
this.$store.commit('CUSTOM_TEST')
alert(this.custom.testValue)
}
},
watch:{
},
mounted(){

},
}




// WEBPACK FOOTER //
// ./src/page/demo/RNDemo.vue